import {
  ChangeDetectionStrategy,
  Component,
  Input,
  HostBinding,
  EventEmitter,
  Output,
} from "@angular/core";
import { LiveInputModel } from "./liveInput.model";
import { LibraryTypes } from "../../../domain/enums";

@Component({
  selector: "live-input",
  templateUrl: "./liveInput.component.html",
  styleUrls: ["./liveInput.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LiveInputComponent {
  @Input()
  index: number = 0;

  @Output()
  playPreview: EventEmitter<LiveInputEvent> = new EventEmitter();

  @Output()
  playLive: EventEmitter<LiveInputEvent> = new EventEmitter();

  @Output()
  saveMediaAtIndex = new EventEmitter();

  @Input()
  isPlayingPreview: boolean = false;

  @Input()
  isPlayingLive: boolean = false;

  @Input()
  inputModel: LiveInputModel = null;

  @HostBinding("class.drag-over") isDragOver: boolean = false;

  ctaTitle: string = "Drag Media";

  /**
   * Starting the component
   */
  ngOnInit() {}

  /**
   * Dispatched when a dragged element enter this input section
   * @param event
   * @return void
   */
  onDragEnter(event) {
    this.isDragOver = true;
    this.ctaTitle = "Drop Media";
  }

  /**
   * Dispatched when a dragged element exit this input section
   * @param event
   * @return void
   */
  onDragLeave(event) {
    this.isDragOver = false;
    this.ctaTitle = "Drag Media";
  }

  /**
   * Dispatched when a dragged element is been dropped on this input section
   * @param event
   * @retrun void
   */
  onDrop(event: DragEvent) {
    let model: LiveInputModel = null;

    if (event.dataTransfer.types.indexOf("text/graphics") > -1) {
      // adding graphic as new element in input model
      if (this.inputModel == null) {
        model = new LiveInputModel(
          LibraryTypes.Graphics,
          null,
          JSON.parse(event.dataTransfer.getData("text/graphics")),
        );
        this.saveMediaAtIndex.emit({ input: model, index: this.index });
      } else {
        // adding graphic to already exist item
        this.inputModel.addAttachedGraphic(
          JSON.parse(event.dataTransfer.getData("text/graphics")),
        );
        this.saveMediaAtIndex.emit({
          input: this.inputModel,
          index: this.index,
        });
      }
    } else if (event.dataTransfer.types.indexOf("text/media") > -1) {
      /* Build Model */
      model = new LiveInputModel(
        LibraryTypes.Video,
        JSON.parse(event.dataTransfer.getData("text/media")),
      );
      this.saveMediaAtIndex.emit({ input: model, index: this.index });
    }

    this.isDragOver = false;
  }

  /**
   * Making the drop target available if it needed
   * @param event
   * @return {boolean}
   */
  makeDropAvailableIfNeeded(event) {
    event.preventDefault();
    return true;
  }

  /**
   * Pressing on preview toggle and making the change
   * @param event
   */
  previewToggle(event) {
    this.playPreview.emit(new LiveInputEvent(this.index, this.inputModel));
  }

  /**
   * Pressing on live toggle and making the change
   * @param event
   */
  liveToggle(event) {
    this.playLive.emit(new LiveInputEvent(this.index, this.inputModel));
  }
}

export class LiveInputEvent {
  constructor(
    public index: number,
    public model: LiveInputModel,
  ) {}

  public stop: boolean = false;
}
